"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AccessAuthenticationPageStateContext_1 = require("./AccessAuthenticationPageStateContext");
var ChooseVerificationMethod_1 = __importDefault(require("./ChooseVerificationMethod"));
var VerificationForm_1 = __importDefault(require("./VerificationForm"));
var CheckEmail_1 = __importDefault(require("./CheckEmail"));
var ConfirmHuman_1 = __importDefault(require("./ConfirmHuman"));
var SecuredByQwilr_1 = require("@CommonFrontend/SecuredByQwilr/SecuredByQwilr");
var AnimatedBackground_1 = require("../AnimatedBackground/AnimatedBackground");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var CrossFade_1 = require("./CrossFade/CrossFade");
var styles = __importStar(require("./AccessAuthentication.css"));
var WhyVerify_1 = __importDefault(require("./WhyVerify"));
var clerk_react_1 = require("@clerk/clerk-react");
var AccessGateSpinner_1 = require("../AccessGateSpinner/AccessGateSpinner");
var AccessAuthenticationTelemetry_1 = require("./AccessAuthenticationTelemetry");
var AuthenticationProvider_1 = __importDefault(require("Public/Identity/AuthenticationProvider"));
var AuthenticationContext_1 = require("Public/Identity/AuthenticationContext");
var identityService_1 = require("./identityService");
var PAGE_STATE_TO_TELEMETRY_STAGE = {
    "verify your details": "enter details",
    "email was sent": "check inbox",
};
var AccessAuthentication = function (props) {
    var setBackgroundPulsing = props.setBackgroundPulsing, backgroundPulsing = props.backgroundPulsing, setPageUnlocked = props.setPageUnlocked, pageUnlocked = props.pageUnlocked;
    var telemetry = (0, AccessAuthenticationTelemetry_1.useAccessAuthTelemetry)();
    var continueUrl = encodeURIComponent(props.pageUrl);
    var _a = (0, clerk_react_1.useAuth)(), isClerkLoaded = _a.isLoaded, isSignedIn = _a.isSignedIn, getToken = _a.getToken;
    var _b = __read((0, react_1.useState)(false), 2), isLoaded = _b[0], setIsLoaded = _b[1];
    var _c = __read((0, react_1.useState)(""), 2), identifySubmissionError = _c[0], setIdentifySubmissionError = _c[1];
    var _d = __read((0, react_1.useState)({
        page: props.isRequiredConfirmationToOpenPage ? "confirm human" : "choose auth method",
    }), 2), pageState = _d[0], setPageState = _d[1];
    (0, react_1.useEffect)(function () {
        if (PAGE_STATE_TO_TELEMETRY_STAGE[pageState.page]) {
            telemetry.track("Email Access Auth Viewed", {
                stage: PAGE_STATE_TO_TELEMETRY_STAGE[pageState.page],
            });
        }
    }, [pageState.page, telemetry]);
    var hasFiredAccessGateTelemetry = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (!hasFiredAccessGateTelemetry.current && pageState.page === "choose auth method") {
            telemetry.track("Qwilr Access Gate Viewed", {
                type: "access auth",
                access_auth_method_enabled: props.enabledAuthMethods,
            });
            hasFiredAccessGateTelemetry.current = true;
        }
    }, [pageState.page, props.enabledAuthMethods, telemetry]);
    var triggerPulse = (0, react_1.useCallback)(function () {
        setBackgroundPulsing(true);
        setTimeout(function () {
            setBackgroundPulsing(false);
        }, kaleidoscope_1.AnimationDuration.Long + 1000);
    }, [setBackgroundPulsing]);
    var autoIdentifyOnRedirect = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var clerkToken, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getToken()];
                case 1:
                    clerkToken = _a.sent();
                    if (!clerkToken) {
                        return [2];
                    }
                    return [4, (0, identityService_1.identifyWithSpringboard)({ submitUrl: props.identifyUrl, clerkToken: clerkToken })];
                case 2:
                    result = _a.sent();
                    if (result.ok !== true) {
                        setIsLoaded(true);
                        setIdentifySubmissionError(result.error);
                        return [2];
                    }
                    setPageUnlocked(true);
                    setTimeout(function () {
                        triggerPulse();
                        window.location.href = result.redirectUrl;
                    }, kaleidoscope_1.AnimationDuration.Long + 1000);
                    return [2];
            }
        });
    }); }, [getToken, props.identifyUrl, setPageUnlocked, triggerPulse]);
    (0, react_1.useEffect)(function () {
        if (props.disableClerk) {
            setIsLoaded(true);
        }
        else {
            if (isClerkLoaded) {
                var shouldAutoIdentify = localStorage.getItem(identityService_1.autoIdentifyOnLoadKey);
                if (shouldAutoIdentify && isSignedIn) {
                    localStorage.removeItem(identityService_1.autoIdentifyOnLoadKey);
                    autoIdentifyOnRedirect();
                }
                else {
                    setIsLoaded(true);
                }
            }
            else {
                setIsLoaded(false);
            }
        }
    }, [props.disableClerk, isClerkLoaded, autoIdentifyOnRedirect, isSignedIn]);
    (0, react_1.useEffect)(function () {
        triggerPulse();
    }, []);
    var getAuthUrl = (0, AuthenticationContext_1.useAuthenticationContext)().getAuthUrl;
    (0, react_1.useEffect)(function () {
        if (isLoaded) {
            setBackgroundPulsing(false);
        }
    }, [isLoaded, setBackgroundPulsing]);
    var loginUrl = getAuthUrl("login", continueUrl, AuthenticationContext_1.AuthenticationOrigin.AccessAuthentication);
    var signupUrl = getAuthUrl("signup", continueUrl, AuthenticationContext_1.AuthenticationOrigin.AccessAuthentication);
    var cardTransitionKey = "".concat(pageState.page, "-").concat(isSignedIn);
    var scrollBoundaryRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var scrollBoundary = scrollBoundaryRef.current;
        if (!scrollBoundary) {
            return;
        }
        scrollBoundary.scrollTo({ left: 0, top: 0, behavior: "smooth" });
    }, [cardTransitionKey]);
    return (react_1.default.createElement(AccessAuthenticationPageStateContext_1.AccessAuthenticationPageStateContext.Provider, { value: {
            pageState: pageState,
            setPageState: setPageState,
        } },
        react_1.default.createElement(AnimatedBackground_1.AnimatedBackground, { pageUnlocked: pageUnlocked, pulsing: backgroundPulsing },
            react_1.default.createElement("div", { className: styles.wrapper, ref: scrollBoundaryRef },
                react_1.default.createElement(AccessGateSpinner_1.AccessGateSpinner, { loading: !isLoaded, pageUnlocked: pageUnlocked, className: styles.spinner }),
                react_1.default.createElement("div", { className: styles.mainCrossFadeWrapper },
                    react_1.default.createElement(CrossFade_1.CrossFade, { elementKey: "".concat(isLoaded.toString(), "-").concat(pageUnlocked) }, isLoaded && !pageUnlocked && (react_1.default.createElement(CrossFade_1.CrossFade, { elementKey: cardTransitionKey },
                        react_1.default.createElement("div", { className: styles.container },
                            react_1.default.createElement(kaleidoscope_1.Card, { elevation: 1, className: styles.card },
                                pageState.page === "email was sent" && (react_1.default.createElement(CheckEmail_1.default, { submitUrl: props.identifyUrl, triggerPulse: triggerPulse })),
                                pageState.page === "verify your details" && (react_1.default.createElement(VerificationForm_1.default, { submitUrl: props.identifyUrl, triggerPulse: triggerPulse })),
                                pageState.page === "choose auth method" && (react_1.default.createElement(ChooseVerificationMethod_1.default, { previewImage: props.previewImage, signupUrl: signupUrl, loginUrl: loginUrl, submitUrl: props.identifyUrl, triggerPulse: triggerPulse, setPageUnlocked: setPageUnlocked, identifySubmissionError: identifySubmissionError, setIdentifySubmissionError: setIdentifySubmissionError, onViewPrivacyStatement: function () {
                                        setPageState({ page: "why verify" });
                                    } })),
                                pageState.page === "why verify" && react_1.default.createElement(WhyVerify_1.default, null),
                                pageState.page === "confirm human" && (react_1.default.createElement(ConfirmHuman_1.default, { updateConfirmationStatusEndpointUrl: props.updateConfirmationStatusEndpointUrl }))),
                            pageState.page === "choose auth method" && !isSignedIn && (react_1.default.createElement("div", { className: styles.logInCta },
                                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" },
                                    "Have a Qwilr Springboard account?",
                                    " ",
                                    react_1.default.createElement(kaleidoscope_1.Link, { onClick: function () { return window.localStorage.setItem(identityService_1.autoIdentifyOnLoadKey, "true"); }, href: loginUrl, target: "" }, "Log in"))))))))),
                react_1.default.createElement("div", { className: styles.securedByQwilr },
                    react_1.default.createElement(SecuredByQwilr_1.SecuredByQwilr, { utmParams: "utm_source=public_page&utm_medium=access_authentication&utm_campaign=secured_by_qwilr", onClick: function () {
                            telemetry.track("Click Secured by Qwilr", {
                                source: "access auth",
                            });
                        } }))))));
};
var WrappedAccessAuthentication = function (props) {
    var _a = __read((0, react_1.useState)(true), 2), backgroundPulsing = _a[0], setBackgroundPulsing = _a[1];
    var _b = __read((0, react_1.useState)(false), 2), pageUnlocked = _b[0], setPageUnlocked = _b[1];
    var authProviderProps = props.authProviderProps, remainingProps = __rest(props, ["authProviderProps"]);
    return (react_1.default.createElement(AuthenticationProvider_1.default, __assign({}, authProviderProps),
        react_1.default.createElement(AccessAuthentication, __assign({}, remainingProps, { setBackgroundPulsing: setBackgroundPulsing, setPageUnlocked: setPageUnlocked, backgroundPulsing: backgroundPulsing, pageUnlocked: pageUnlocked }))));
};
exports.default = WrappedAccessAuthentication;
